import { Divider, Grid, Paper, Typography } from "@material-ui/core";
import LoaderBar from "components/LoaderBar/LoaderBar";
import PageTitle from "components/PageTitle/PageTitle";
import InvertedTable from "components/Table/InvertedTable";
import { useState } from "react";
import { dbGet } from "utils/DBFetchers";

import useStyles from "../styles";
import { AuditBurnableSelectionForm } from "./AuditBurnableSelectionForm";
import { map } from "lodash";
const GOAL = 5;

const POLLING_INTERVAL = 3000; // 3 segundos

export default function AuditBurnableDashboard() {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const adaptResponseToInvertedTable = (data) => {
    const summary = data.summary;

    const months = Object.keys(summary).sort();

    const labelMap = {
      audited_money_mm: "Monto Auditado (MM)",
      audited_units: "Unidades Auditadas",
      claimed_money_mm: "Monto Reclamado (MM)",
      claimed_units: "Unidades Reclamadas",
      rejected_money_mm: "Monto Rechazado (MM)",
      rejected_units: "Unidades Rechazadas",
      pct_rejected_money: "% Rechazo (Monto)",
      pct_rejected_units: "% Rechazo (Unidades)",
    };

    const metrics = Object.keys(labelMap);

    const rows = metrics.map((metric) => ({
      label: labelMap[metric],
      category: "data",
      data: months.map((month) => {
        const val = summary[month][metric];
        return typeof val === "number" ? val : 0;
      }),
    }));
    const formattedMonths = months.map(m => `${m.slice(0, 4)}-${m.slice(4)}`);
    const columns = formattedMonths;

    return { rows, columns };
  };

  const renderTables = () => {
    const { rows, columns } = adaptResponseToInvertedTable(data);
    return (
      <>
        <Grid
          item
          xs={12}
          lg={12}
          style={{ marginBottom: "2%", marginTop: "2%", marginLeft: "2.5%" }}
        >
          <Typography variant="h4" className={classes.alignedText}>
            Valores
          </Typography>
          <Divider />
        </Grid>
        <Paper style={{ marginTop: "30px" }}>
          <InvertedTable
            title="Indicador"
            rows={rows}
            columns={columns}
            goal={GOAL}
          />
        </Paper>
      </>
    );
  };

  const renderLoadingSection = () => {
    return (
      <Grid
        item
        container
        justifyContent="center"
        xs={12}
        style={{ paddingTop: "2%" }}
      >
        <LoaderBar />
      </Grid>
    );
  };

  const defineSectionToShow = () => {
    if (isLoading) return renderLoadingSection();
    if (data === null) return <></>;
    return renderTables();
  };

  const onApplyFilters = (filters) => {
    setIsLoading(true);
    const baseUrl = "audit/burnable/summary";

    const fromDatePeriod =
      filters.fromDate.getFullYear() * 100 + (filters.fromDate.getMonth() + 1);
    const toDatePeriod =
      filters.toDate.getFullYear() * 100 + (filters.toDate.getMonth() + 1);

    const rawParams = {
      from_period: fromDatePeriod,
      to_period: toDatePeriod,
      distributor_ids: filters.distributor,
      status_type: filters.statusType,
      error_ids: filters.errors,
      zone_id: filters.zone?.id,
      import_id_filter: filters.importId,
      presentation_id: filters.presentation?.id,
      business_area: filters.businessArea,
      brand: filters.brand,
    };
    // Reemplazamos null/undefined por ""
    const sanitizedParams = Object.fromEntries(
      Object.entries(rawParams).map(([key, value]) => [
        key,
        value == null ? "" : value,
      ]),
    );

    const queryParams = new URLSearchParams(sanitizedParams);
    const fullUrl = `${baseUrl}?${queryParams.toString()}`;

    dbGet(fullUrl)
      .then((initialResponse) => {
        const requestId = initialResponse?.id;

        if (!requestId) {
          throw new Error("No se recibió un ID de request");
        }

        // Iniciar polling
        pollRequestStatus(requestId);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("Error al iniciar la request:", err?.message || "Unknown error");
      });
  };

  const pollRequestStatus = (requestId) => {
    const intervalId = setInterval(() => {
      dbGet(`/request_checker/status?id=${requestId}`)
        .then((statusResponse) => {
          if (statusResponse?.status === "Completed") {
            clearInterval(intervalId);
            setIsLoading(false);
            setData(statusResponse.data);
          } else if (statusResponse?.status === "Failure") {
            clearInterval(intervalId);
            setIsLoading(false);
            console.error("La request falló");
          }
          // Si sigue pendiente, no hacemos nada y esperamos al siguiente intervalo
        })
        .catch((err) => {
          clearInterval(intervalId);
          setIsLoading(false);
          console.error("Error al hacer polling:", err?.message || "Unknown error");
        });
    }, POLLING_INTERVAL);
  };

  return (
    <Grid>
      <PageTitle title="Panel de Control - Auditoría Quemables" />
      <Paper elevation={3}>
        <Grid
          container
          xs={12}
          md={12}
          lg={12}
          layout={"row"}
          spacing={"1"}
          style={{ border: "1px" }}
        >
          <AuditBurnableSelectionForm onApplyFilters={onApplyFilters} />
        </Grid>
      </Paper>
      {defineSectionToShow()}
    </Grid>
  );
}
